import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRing = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.2463 8.40844L15.4419 6.21285C15.442 6.2128 15.442 6.2127 15.4421 6.21265C15.686 5.96861 15.6859 5.57305 15.4419 5.32907L12.3169 2.20406C12.3168 2.20401 12.3168 2.20396 12.3167 2.20391C12.0727 1.95998 11.6771 1.96003 11.4331 2.20406L8.30812 5.32907C8.30801 5.32916 8.30796 5.32921 8.30791 5.32926C8.06398 5.5733 8.06407 5.96891 8.30811 6.21285L10.5037 8.40843C7.3639 9.04413 5 11.8187 5 15.146C5 18.943 8.07806 22.021 11.875 22.021C15.6701 22.0165 18.7456 18.9411 18.75 15.146C18.75 11.8187 16.3861 9.04408 13.2463 8.40844ZM11.875 3.52969L14.1163 5.7709L11.875 8.01218L9.63375 5.77095L11.875 3.52969ZM11.875 20.771C8.76842 20.771 6.25 18.2526 6.25 15.146C6.25 12.0394 8.76842 9.52096 11.875 9.52096C14.9802 9.52437 17.4967 12.0408 17.5 15.146C17.5 18.2526 14.9816 20.771 11.875 20.771Z",
		fill: "currentColor"
	})
});
export default SvgRing;
